/** 롱텀케어 자료요청(매크로) — 방문요양·방문목욕만 지원 */
export const LTCS_MACRO_BIZ_GUBUN_LIST = ['방문요양', '방문목욕'] as const;

export type LtcsMacroBizGubun = (typeof LTCS_MACRO_BIZ_GUBUN_LIST)[number];

export function isLtcsMacroBizGubun(biz: string | null | undefined): boolean {
  const b = String(biz ?? '').trim();
  return (LTCS_MACRO_BIZ_GUBUN_LIST as readonly string[]).includes(b);
}

/** cmq_type → LTCS API configKey */
export const LTCS_TYPE_TO_CONFIG_KEY: Record<string, string> = {
  caion_ltcs_recipient_info: 'recipient_info',
  caion_ltcs_emp_info: 'caregiver_info',
  caion_ltcs_schedule_plan: 'caregiver_plan',
  caion_ltcs_caregiver_plan: 'caregiver_plan',
  caion_ltcs_caregiver_info: 'caregiver_info',
  caion_ltcs_rfid: 'rfid',
  caion_ltcs_claim: 'claim',
  caion_ltcs_claim_detail: 'claim_detail',
  caion_ltcs_labor_cost: 'labor_cost',
};

export const LTCS_CONFIG_KEY_TO_ENDPOINT: Record<string, string> = {
  recipient_info: '/ltcs/recipient-info',
  caregiver_info: '/ltcs/caregiver-info',
  caregiver_plan: '/ltcs/caregiver-plan',
  rfid: '/ltcs/rfid',
  claim: '/ltcs/claim',
  claim_detail: '/ltcs/claim-detail',
  labor_cost: '/ltcs/labor-cost',
};

/** cmq_type → duplicates API endpoint */
export function getLtcsDuplicatesEndpoint(ltcsType: string): string | null {
  const configKey = LTCS_TYPE_TO_CONFIG_KEY[normalizeLtcsTypeKey(ltcsType)];
  if (!configKey) return null;
  const base = LTCS_CONFIG_KEY_TO_ENDPOINT[configKey];
  if (!base) return null;
  if (configKey === 'labor_cost') return '/ltcs/labor-cost/duplicates';
  return `${base}/duplicates`;
}

function normalizeLtcsTypeKey(type: string): string {
  if (type === 'caion_ltcs_caregiver_plan') return 'caion_ltcs_schedule_plan';
  if (type === 'caion_ltcs_caregiver_info') return 'caion_ltcs_emp_info';
  return type;
}

/** cmq_type → idx 컬럼명 */
export const LTCS_TYPE_IDX_KEY: Record<string, string> = {
  caion_ltcs_recipient_info: 'clsr_idx',
  caion_ltcs_emp_info: 'clci_idx',
  caion_ltcs_schedule_plan: 'clsp_idx',
  caion_ltcs_caregiver_plan: 'clsp_idx',
  caion_ltcs_rfid: 'clrf_idx',
  caion_ltcs_claim: 'clc_idx',
  caion_ltcs_claim_detail: 'clcd_idx',
  caion_ltcs_labor_cost: 'cllc_idx',
};
